<script>
export default {
  name: 'Modal',
}
</script>

<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="text-right"
            ><svg class="icon icon-4 text-secondary" @click="$emit('close')">
              <title>Close</title>
              <use
                xlink:href="../assets/images/brinkshome_icons.svg#icon-delete"
              ></use></svg
          ></div>
          <div class="modal-header">
            <slot name="header">
              default header
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer"> </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="scss">
@import '@design';

.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9998;
  display: table;
  width: 100%;
  height: 100%;
  background-color: $color-modal-mask;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 75%;
  margin: 0 auto;
  background-color: $color-body-bg;
  transition: all 0.3s ease;
}

.modal-header {
  display: block;
  align-content: center;
  text-align: center;
  border-bottom: 0;
  padding: 0.5em;
  padding-top: 0;
}

.modal-body {
  padding: 0.5em 1em;
  margin: 0 0;
  text-align: center;
}

.modal-body p {
  font-size: 1.1em;
}

.modal-footer {
  padding: 0;
  border-bottom: 0;
}

.modal-default-button {
  float: right;
}

@media (min-width: 768px) {
  .modal-container {
    width: 60%;
  }
}

@media (max-width: 768px) {
  .modal-container {
    width: 90%;
  }
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
